import { render, staticRenderFns } from "./epg-grid-item.vue?vue&type=template&id=2d5477d9"
import script from "./epg-grid-item.vue?vue&type=script&lang=js"
export * from "./epg-grid-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports